// Reusable Card component
import React, { forwardRef } from 'react';

const Card = forwardRef(({ children, title, className = '', onClick, clickable = false }, ref) => {
  const baseClasses = 'bg-white rounded-lg shadow-md p-6';
  const clickableClasses = clickable ? 'cursor-pointer hover:shadow-lg transition-shadow duration-200' : '';

  return (
    <div
      ref={ref}
      className={`${baseClasses} ${clickableClasses} ${className}`}
      onClick={onClick}
    >
      {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
